/**
 * HR Lifecycle Dashboard API.
 */
import { apiFetch } from './core'

export const hrDashboard = {
    lifecycle: (params = {}) => {
        const qs = new URLSearchParams(params).toString()
        return apiFetch(`/hr-dashboard/lifecycle${qs ? `?${qs}` : ''}`)
    },
    birthdays: (params = {}) => {
        const qs = new URLSearchParams(params).toString()
        return apiFetch(`/hr-dashboard/birthdays${qs ? `?${qs}` : ''}`)
    },
    employeesOverview: () => apiFetch('/hr-dashboard/employees-overview'),
    recruitingOverview: () => apiFetch('/hr-dashboard/recruiting-overview'),
    hiringSources: (params = {}) => {
        const qs = new URLSearchParams(params).toString()
        return apiFetch(`/hr-dashboard/hiring-sources${qs ? `?${qs}` : ''}`)
    },
}
